export const SET_TITLE = 'SET_TITLE';
export const APP_SET_INSTALLED = 'APP_SET_INSTALLED';
export const APP_SET_ONLINE = 'APP_SET_ONLINE';
export const APP_SET_OFFLINE = 'APP_SET_OFFLINE';
